import {createI18n} from 'vue-i18n';
import {deMessages} from '@/common/i18n/de';

export const i18n = createI18n<false>({
  legacy: false,
  locale: 'de',
  messages: {
    de: deMessages,
  },
});
